import { Component, OnInit, Input, Inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/internal/operators/finalize';
import { map } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { FirestoreService, SidebarService } from 'src/app/services/service.index';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-createcompany',
  templateUrl: './createcompany.component.html',
  styleUrls: ['./createcompany.component.css']
})
export class CreatecompanyComponent implements OnInit {

  @Input() user: any;


  urlImg:any = "../../../assets/img/images.jpeg";
  imageTemp: string;

  cliente:any = {};

  selectedFile: File = null;
  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;

  activo = false;

  mensajeArchivo = '';
  nombreArchivo = '';

  porcentaje :any ='';
  snapshot:any;
  finalizado = false;
  total = 0;
  img = false;

  nueva:any;

  banDir = false;

  addressDir: any;
  address: any;
  lat: any;
  lng: any;
  regionName: any;
  region: any;
  marker: google.maps.Marker;
  map: any;
  gmap: any;

  forma: FormGroup;

  constructor( private storage: AngularFireStorage, private afs: FirestoreService, @Inject(DOCUMENT) private document,  private router: Router, public _sidebar: SidebarService) { }

  ngOnInit(): void {


    this.user = this.afs.usersShow;

    this.forma = new FormGroup({
      companyname: new FormControl( null, Validators.required),
      typecompany: new FormControl(" "),
      address: new FormControl(null, Validators.required),
      lat: new FormControl(""),
      lng: new FormControl(""),
      description: new FormControl(),
      status: new FormControl(1)
    });

  }

  ngDestroy(){




  }

  createCompany(){

    this.forma.value.img = this.urlImg;

    console.log(this.forma.value);

    var data = this.forma.value;
    var users = {};
    users[this.user.id] = true;
    data['employees'] = users;


    this.afs.createCompany(data).then((res) => {



        console.log(res.id);
        console.log(this.user);

        let userRes = this.user;

        userRes.companyId = res.id;

        this.afs.updateUser(this.user.id, userRes).then(res => {

           Swal.fire('Good job!', 'User ha been updated!', 'success');


             this.router.navigate(['/dashboard']);




        }).catch(err =>{

          Swal.fire('Oops...', 'User has not been registered!', 'error');

        });

    }).catch(err => {


        Swal.fire('Oops...', 'User has not been registered!', 'error');

        console.log(err);

    });

  }

  cambioArchivo(event) {


    if(  event.target.files[0].type.indexOf("image")<0){

      Swal.fire('Oops...', 'Should image!', 'error');
      return;
    }

    let reader = new FileReader();

    let urlImageTemp = reader.readAsDataURL(event.target.files[0]);

    reader.onloadend = () => {
          this.urlImg = reader.result;
    }

    this.activo = false;
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.mensajeArchivo = `Archivo preparado`; //: ${event.target.files[i].name};
        this.nombreArchivo = event.target.files[i];
        this.document.getElementById('uploader3').value = event.target.files[i].name;
        //console.log(this.nombreArchivo);
        if(this.nombreArchivo){
            this.subirArchivo();
        }
      }
    } else {
      this.mensajeArchivo = 'No hay un archivo seleccionado';
    }
  }

  subirArchivo() {

    this.total = 0;

    //console.log(this.nombreArchivo);
    let n = Date.now();
    const filePath = `armandobucket/${n}`;
     let referencia = this.storage.ref(filePath);
     let tarea = this.storage.upload(`armandobucket/${n}`,this.nombreArchivo);

     //Cambia el porcentaje

     this.activo = true;

     this.porcentaje = tarea.percentageChanges();


       // get notified when the download URL is available
      tarea.snapshotChanges().pipe(
         map(
            x => {  this.total = Math.round((x.bytesTransferred/x.totalBytes) * 100); /*console.log(this.total)*/ }
         ),
         finalize(async () => {

                                 this.downloadURL = await referencia.getDownloadURL().toPromise();

                                 console.log(this.downloadURL);


                                 this.urlImg = this.downloadURL;


                                // this.db.collection('files').add( { img: this.urlImg })

                                 setTimeout(() => {
                                       this.activo = false;
                                       this.img =true;
                                 },600)

                         })
      )
     .subscribe()
   }


   getAddress(place: object) {

    this.addressDir = place['formatted_address'];
    this.address = place['geometry'];
    //this.registro.direccion = this.addressDir;

    this.lat = this.address.location.lat();
    this.lng = this.address.location.lng();


    /*this.afs.getAllRegionPro().then(res =>{

        res.forEach((doc)=>{
            //console.log(doc.id);
            //console.log(doc.data());

            let location = [ this.lat, this.lng];

            let idRegion = doc.id;
            let regionData = doc.data();
            let regionPolygon = doc.data().polygon;

            let  pointArr = [];

            Object.keys(regionPolygon).forEach((id) => {
                var point = [
                    regionPolygon[id].lat,
                    regionPolygon[id].lng,
                ];
                pointArr.push(point);
            });

            //console.log(pointArr);

            if(this.afs.inside(location, pointArr)){
                //console.log(regionData.name);
                this.regionName = regionData.name;
                this.region = idRegion;
                this.forma.controls['region'].setValue(this.regionName);
            }

        });

    }).catch(err=>{
        console.log(err);
    });*/


    this.forma.controls['lng'].setValue(this.lat);
    this.forma.controls['lat'].setValue(this.lng);
    this.forma.controls['address'].setValue(this.addressDir);


    /*const coordinates = new google.maps.LatLng(this.lat, this.lng);

    this.marker = new google.maps.Marker({
      position: coordinates,
      map: this.map
    })

    const mapOptions: google.maps.MapOptions = {
      // here to place centering our location based on coordinates
      center: coordinates,
      zoom: 18,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false
      };

      this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
      this.marker.setMap(this.map);*/

     }


}
